import { OptimisationResult } from '../shared/models/optimisation-result.model';
import { RunHistory } from './run-history.model';

export class Run {
    runId: string;
    name: string;
    initiatedBy: string;
    runHistories: RunHistory[];
    optimisationResult?: OptimisationResult;

    constructor() {
        this.runId = "";
        this.name = "";
        this.initiatedBy = "";
        this.runHistories = [];
    }
}